import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import environment from "../../utils/Environment";
import { getGemsTokenContract } from "../../utils/contractHelpers";
import Web3 from "web3";

const ApproveGems = () => {
  const web3 = useWeb3()
  // const tokenAddress = environment.gems;
  // const contract = getGemsTokenContract(tokenAddress, web3);
  const approveGems = useCallback(
    async (account, amount, tokenAddress, decimals) => {
      const contract = getGemsTokenContract(tokenAddress, web3);
      let nd = '9999999999999999999999999';
      console.log(nd, 'ndndndndndndndn');
      // nd = web3.utils.toWei(nd.toString(), "ether");
      try {
        const details = await contract.methods
        .approve(environment.GemsSubscription, nd)
        .send({
          from: account,
          // gas,
        });
      return details;
      } catch (error) {
        console.log(error, 'Get Gems Premium approve');
        
        throw error;
      }
    },
    [web3]
  );
  return { approveGems: approveGems };
};
export default ApproveGems;
